import { getPageEntries, getEntry } from "utils/contentful/api";
import { withRouter } from "next/router";
import Layout from "components/Layout";
import Error from "pages/_error";
import Landing from "components/Landing/Landing";

const LandingPage = ({ router, preloadData, pageData, headData }) => {
  if (!pageData || router.isFallback) {
    return <Error statusCode={404} />;
  }

  const { metaTitle, giftingCTA, sections } = pageData;

  const testimonialsData =
    sections?.find?.((s) => s.slug === "testimonial-carousel") || null;
  const testimonials =
    testimonialsData?.references?.filter((t) => t.type === "testimonial") || [];

  return (
    <Layout
      isHomePage
      noContainer
      pageTitle={metaTitle}
      preloadData={preloadData}
      showGiftingCTA={giftingCTA}
    >
      <Landing testimonials={testimonials} headData={headData} />
    </Layout>
  );
};

export const getServerSideProps = async () => {
  const [pageData, headData] = await Promise.all([
    // @TODO: rename slug in contentful to make this default CMS entry for landing
    getPageEntries("kids-exp-43245"),
    getEntry("75YpQtdEEFaXqNI16ZcKZ1"),
  ]);

  return {
    props: {
      pageData,
      headData,
    },
  };
};

export default withRouter(LandingPage);
